import { toRefs, reactive, computed } from 'vue';

const createContext = (client) => {
    const context = toRefs(reactive({
        logtoClient: client,
        isAuthenticated: false,
        loadingCount: 1,
        error: undefined,
    }));
    const { isAuthenticated, loadingCount, error } = context;
    const isLoading = computed(() => loadingCount.value > 0);
    /* eslint-disable @silverhand/fp/no-mutation */
    const setError = (_error, fallbackErrorMessage) => {
        if (_error instanceof Error) {
            error.value = _error;
        }
        else if (fallbackErrorMessage) {
            error.value = new Error(fallbackErrorMessage);
        }
        console.error(error);
    };
    const setLoading = (isLoading) => {
        if (isLoading) {
            loadingCount.value += 1;
        }
        else {
            loadingCount.value = Math.max(0, loadingCount.value - 1);
        }
    };
    const setIsAuthenticated = (_isAuthenticated) => {
        isAuthenticated.value = _isAuthenticated;
    };
    /* eslint-enable @silverhand/fp/no-mutation */
    (async () => {
        const isAuthenticated = await client.isAuthenticated();
        setIsAuthenticated(isAuthenticated);
        setLoading(false);
    })();
    return { ...context, isLoading, setError, setLoading, setIsAuthenticated };
};
const throwContextError = () => {
    throw new Error('Must install Logto plugin first.');
};

export { createContext, throwContextError };
